export type ListboxNavigationKey = 'ArrowDown' | 'ArrowUp' | 'Home' | 'End';

const NAVIGATION_KEYS: readonly string[] = ['ArrowDown', 'ArrowUp', 'Home', 'End'];

export const isListboxNavigationKey = (key: string): key is ListboxNavigationKey =>
    NAVIGATION_KEYS.includes(key);

export const nextListboxActiveIndex = (current: number, key: ListboxNavigationKey, count: number): number => {
    if (count <= 0) return -1;
    const last = count - 1;
    const from = Math.min(current, last);
    switch (key) {
        case 'Home':
            return 0;
        case 'End':
            return last;
        case 'ArrowDown':
            return from < 0 ? 0 : Math.min(from + 1, last);
        case 'ArrowUp':
            return from < 0 ? last : Math.max(from - 1, 0);
    }
};

export const initialListboxActiveIndex = (selectedIndex: number, count: number): number => {
    if (count <= 0) return -1;
    return selectedIndex >= 0 && selectedIndex < count ? selectedIndex : 0;
};
